import classes from './InvisiButton.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode
  onClick?: () => void
  isDisabled?: boolean
  title?: string
  hasHoverEffect?: boolean
  hasBackgroundColor?: boolean
  hasPadding?: boolean
  label?: string
}

const InvisiButton = ({
  children,
  onClick,
  title,
  isDisabled,
  hasBackgroundColor = true,
  hasHoverEffect = false,
  hasPadding = true,
  label = ''
}: Props) => {
  const backgroundStyle = hasHoverEffect
    ? classes.HasHoverEffect
    : ''

  const paddingStyle = !hasPadding
    ? classes.NoPadding
    : ''

  const backgroundColor = !hasBackgroundColor
    ? classes.NoBackgroundColor
    : ''

  const buttonClass = [
    classes.InvisiButton,
    backgroundStyle,
    paddingStyle,
    backgroundColor
  ].filter(classStyle => classStyle).join(' ')

  return (
    <button
      aria-label={label}
      className={buttonClass}
      disabled={isDisabled}
      onClick={onClick || (() => { })}
      title={title}
      type='button'
    >
      {children}
    </button>
  )
}

export default InvisiButton
